// app.component.ts
import { CommonModule } from '@angular/common'; // ← ADD THIS
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'fw-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ToastModule,
    CommonModule, // ← ADD THIS LINE
    // AsyncPipe is included in CommonModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
